import { IncomingHttpHeaders } from 'http';

import { ContentApiGetGeneralPageRequest } from '@/generated-client/content-a';
import logger from '@/utils/logger';

import { createContentApi } from './create-content-api';

export const MEMBERSHIP_DASHBOARD_SELECTION_KEY = 'membership-dashboard';
export const SIGN_UP_V2_SELECTION_KEY = 'sign-up-v2';
export const LOYALTY_PAGE_ID = 'loyalty-sign-up';

interface Props {
  market: string;
  selectionKey?: string;
  headers?: IncomingHttpHeaders;
}

interface SafeFetchProps extends Props {
  rid?: string | string[];
}

/**
 * This service request is rewritten to https://www-{ENV}.chewy.net/api/content/v1/pages/general/types/loyalty-sign-up
 * via middleware.ts
 * @returns ContentPageModel
 */
export const fetchGeneralContentPage = ({ market, selectionKey, headers }: Props) => {
  const contentApi = createContentApi(market, headers);

  const generalPageRequest: ContentApiGetGeneralPageRequest = {
    generalType: LOYALTY_PAGE_ID,
    ...(selectionKey && { selectionKey }),
  };

  return contentApi
    .getGeneralPage(generalPageRequest)
    .then(({ data }) => data)
    .catch(error => {
      throw error;
    });
};

export const fetchGeneralContentPageSafely = async ({ rid, ...props }: SafeFetchProps) => {
  try {
    return await fetchGeneralContentPage(props);
  } catch (error: unknown) {
    logger.error(
      `Failed to fetch CMS content for selectionKey=${props.selectionKey}, rid: ${rid}`,
      error,
    );
    return undefined;
  }
};
